import { Injectable } from '@angular/core';
import { WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';

@Injectable()

export class ExecuteFormsUIState {
  constructor(
    private localePipe: WfLocalePipe
  ){}
    public formTypeCollection = [
        { text: this.localePipe.transform('component.executeForms.processEmbeddedForm'), value: '0' },
        { text: this.localePipe.transform('component.executeForms.formEmbedProcess'), value: '1' },
    ];

}
